// plugins/karakuri.client.ts
export default defineNuxtPlugin(() => {
  const script = document.createElement("script")
  script.src = "https://faq.tential.jp/suggest.js"
  script.defer = true
  script.setAttribute("data-karakuri-input-id", "contact_form_text_area")
  script.setAttribute("data-karakuri-embed-id", "contact_form_suggest_area")
  document.head.appendChild(script)
})
